export const PASSWORD = 'PASSWORD';
export const CONFIRMATION = 'CONFIRMATION';
export const NOTIFICATION = 'NOTIFICATION';
export const REGISTRATION_LIMIT = 'REGISTRATION_LIMIT';
export const JOIN_LIMIT = 'JOIN_LIMIT';
export const APPROVAL = 'APPROVAL';
export const QUESTIONS = 'QUESTIONS';
export const RECORDING = 'RECORDING';
export const RESTRICT_DOMAINS = 'RESTRICT_DOMAINS';
export const CALENDAR_INVITE = 'CALENDAR_INVITE';
